import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button, Spinner, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useProductApi from '../../../managers/ProductManager';

interface FeaturedProductListProps {
  numProducts?: number;
}

const FeaturedProductList: React.FC<FeaturedProductListProps> = ({ numProducts = 8 }) => {
  const navigate = useNavigate();
  const { getProducts } = useProductApi();
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentProducts = async () => {
      try {
        const result = await getProducts("FEATURED", numProducts);
        setProducts(result.items || []);
      } catch (err) {
        console.error('Error fetching featured products', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentProducts();
  }, []);

  const handleProductClick = (product: any) => {
    const isTemplate = product.statusTag === 'TEMPLATE';

    if (isTemplate) {
      navigate(`/products/template/${product.productId}`);
    } else {
      // Use category from product (populated from catalog), fallback to tags, then uncategorized
      const category = product?.catalogItemCategory || (product?.tags && product?.tags?.length > 0 ? product.tags[0] : "uncategorized");
      const catalogItemId = product?.catalogItemVariantId || "unknown-catalogItemId";
      navigate(`/products/${catalogItemId}/${category}/${product.productId}`);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner size="sm" animation="border" />
      </div>
    );
  }

  return (
    <>
      <Row>
        {products.map((product, index) => {
          const isTemplate = product.statusTag === 'TEMPLATE';

          return (
            <Col key={index} xs={6} sm={6} md={4} lg={3}>
              <Card className="mb-4 h-100 border-0">
                <div
                  className="position-relative"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleProductClick(product)}
                >
                  <Card.Img
                    variant="top"
                    src={product.previewImageUrls?.[0]}
                    alt={product.name}
                    className="img-fluid ws-img-clickable"
                  />
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row className="text-center mb-5">
        <Col>
          <Button
            variant="success"
            size="lg"
            onClick={() => navigate('/products')}
            className="w-100 w-md-auto py-3 py-md-2"
          >
            Browse All Designs
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default FeaturedProductList;
